import { Injectable, effect, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { io, Socket } from 'socket.io-client';


@Injectable({
  providedIn: 'root'
})
export class QuotingToolService {

  private stepperQuote = signal<number>(0);
  // private socket!: Socket;
  private apiUrl = 'ws://localhost:8003'; 

  private quotePercentage = signal<any>('');
  
  updateQuotePercentage(value: any) {
    this.quotePercentage.set(value);
  }

  getQuotePercentage() {
    return this.quotePercentage;
  }
  
  updateStepper(value: number) {
    this.stepperQuote.set(value);
  }

  getStepper() {
    return this.stepperQuote;
  }

  private stepperEQuote = signal<number>(0);
  
  updateEStepper(value: number) {
    this.stepperEQuote.set(value);
  }

  getEStepper() {
    return this.stepperEQuote;
  }

  quoteUrl = environment.quote_url;
  constructor(private http: HttpClient) {
    // this.socket = io(this.apiUrl);
   }

  private ResolveApiProject(endpoint: string): string {
    return this.quoteUrl + 'mproject/' + endpoint;
  }

  public CreateProject(data: any): Observable<any> {
    let apiURL = this.ResolveApiProject('addproject');
    return this.http.post(apiURL, data);
  }

  public GetProjectDatabyID(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getprojectById/${id}`);
    return this.http.get(apiURL);
  }

  public EditProject(id:any,data:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`updateproject/${id}`);
    return this.http.post(apiURL,data);
  }

  public UploadDocument(data:any):Observable<any> {
    let apiURL = this.ResolveApiProject('uploadrfcdocument');
    return this.http.post(apiURL,data)
  }

  public AddGerberFile(data:any):Observable<any> {
    let apiURL = this.ResolveApiProject('addrfcBygarberdetail');
    return this.http.post(apiURL,data)
  }

  public AddCadFile(data:any):Observable<any> {
    let apiURL = this.ResolveApiProject('addrfcByCaddetail');
    return this.http.post(apiURL,data)
  }

  public AddGerberCadFile(data:any):Observable<any> {
    let apiURL = this.ResolveApiProject('addrfcByGarberCaddetail');
    return this.http.post(apiURL,data)
  }

  public GetProjectByGerberFiles(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getprojectByGarberFiles/${id}`);
    return this.http.get(apiURL);
  }

  public GetSpecificationDropdownData(): Observable<any> {
    let apiURL = this.ResolveApiProject(`getSpecificationData`);
    return this.http.get(apiURL);
  }

  public SignUpNDA(id:any,data: any): Observable<any> {
    let apiURL = this.ResolveApiProject(`signupNDA/${id}`);
    return this.http.put(apiURL, data);
  }

  public PcbSpecification(id:any,data:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`updaterfcBySpecificationPCB/${id}`);
    return this.http.post(apiURL,data);
  }

  public GetGerberPCBDetailsbyID(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getrfcBySpecificationPCBData/${id}`);
    return this.http.get(apiURL);
  }

  public GetComplianceData(): Observable<any> {
    let apiURL = this.ResolveApiProject(`getCertification`);
    return this.http.get(apiURL);
  }

  public GetEbomTableData(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getEbomSavedRequestJson/${id}`);
    return this.http.get(apiURL);
  }

  public GetSpecificationDimentionsData(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getGerberReadData/${id}`);
    return this.http.get(apiURL);
  }

  public postEbomTableData(data:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`vendor`); 
    return this.http.post(apiURL,data);
  }

  public FetchVendorPrice(data:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`vendorfetchprice`); 
    return this.http.post(apiURL,data);
  }

  public UploadEbomExcel(data: any): Observable<any> {
    let apiURL = this.ResolveApiProject(`uploadEBomFile`);
    return this.http.post(apiURL, data);
  }

  public GetQuotationData(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getviewquotation/${id}`);
    return this.http.get(apiURL);
  }

  public GetRfcLocation(id:any): Observable<any> {
    let apiURL = this.ResolveApiProject(`getrfcdocumentLocation/${id}`);
    return this.http.get(apiURL);
  }

  //E-Quotation

  
  GetAllMasterServices(): Observable<any> {
    const apiURL = `${environment.equote_url}/master-service`;
    return this.http.get<any>(apiURL);
  }

  AddServiceRequirement(data:any): Observable<any> {
    const apiURL = `${environment.equote_url}/add-service-requirement`;
    return this.http.post<any>(apiURL,data);
  }

  GetSelectedServices(iProjectId:any): Observable<any> {
    const apiURL = `${environment.equote_url}/selected-service-requirement?iProjectId=${iProjectId}`;
    return this.http.get<any>(apiURL);
  }

  GetServiceQuestions(iMasterServiceId:any): Observable<any> {
    const apiURL = `${environment.equote_url}/service-requirement-questions?iMasterServiceId=${iMasterServiceId}`;
    return this.http.get<any>(apiURL);
  }

  SaveProductRequirement(reqJson:any): Observable<any> {
    const formData = new FormData();
    
    const files = [...reqJson.files];
    for (let i = 0; i < files.length; i++) {
      formData.append(`files${i}`, files[i]);
    }
    formData.append("iProjectId", reqJson.iProjectId);
    formData.append("iCurrencyStatus",reqJson.iCurrencyStatus);// 1=INR , 2=Doller
    formData.append("vProductDescription", reqJson.vProductDescription);
    if(reqJson.isProductRangeUnknown===false){
      formData.append("iProductMinRange", reqJson.iProductMinRange);
      formData.append("iProductMaxRange", reqJson.iProductMaxRange);
    }else{
      formData.append("isProductRangeUnknown", reqJson.isProductRangeUnknown);
    }
    formData.append("vProductUrl", reqJson.vProductUrl);

    const apiURL = `${environment.equote_url}/add-product-requirement`;
    return this.http.post<any>(apiURL,formData);
  }

  UpdateProductRequirement(reqJson:any): Observable<any> {
    const formData = new FormData();
    
    const files = [...reqJson.files];
    for (let i = 0; i < files.length; i++) {
      formData.append(`files${i}`, files[i]);
    }
    formData.append("iProductRequirementId",reqJson.iProductRequirementId);

    formData.append("iProjectId", reqJson.iProjectId);
    formData.append("vProductDescription", reqJson.vProductDescription);
    if(reqJson.isProductRangeUnknown===false){
      formData.append("iProductMinRange", reqJson.iProductMinRange);
      formData.append("iProductMaxRange", reqJson.iProductMaxRange);
    }else{
      formData.append("isProductRangeUnknown", reqJson.isProductRangeUnknown);
    }
    formData.append("vProductUrl", reqJson.vProductUrl);

    const apiURL = `${environment.equote_url}/update-product-requirement`;
    return this.http.put<any>(apiURL,formData);
  }

  GetEngineeringQuotation(iProjectId:any): Observable<any> {
    const apiURL = `${environment.equote_url}/view-eng-quotation?iProjectId=${iProjectId}`;
    return this.http.get<any>(apiURL);
  }

  GetServiceQuestionsAnswers(iProjectId:any,iMasterServiceId:any): Observable<any> {
    const apiURL = `${environment.equote_url}/service-requirement?iProjectId=${iProjectId}&iMasterServiceId=${iMasterServiceId}`;
    return this.http.get<any>(apiURL);
  }

  UpdateServiceRequirement(data:any): Observable<any> {
    const apiURL = `${environment.equote_url}/update-service-requirement`;
    return this.http.put<any>(apiURL,data);
  }

  GetProductRequirement(iProjectId:any,iProductRequirementId:any): Observable<any> {
    const apiURL = `${environment.equote_url}/product-requirement-by-id?iProjectId=${iProjectId}&iProductRequirementId=${iProductRequirementId}`;
    return this.http.get<any>(apiURL);
  }

  DeleteProductFile(iProjectId:any,iProductRequirementId:any,_id:any){
    const apiURL = `${environment.equote_url}/delete-product-file?iProjectId=${iProjectId}&iProductRequirementId=${iProductRequirementId}&_id=${_id}`;
    return this.http.put<any>(apiURL,'');
  }

// socket implemention

 // Observable to listen for progress updates
//  onProgressUpdate(projectId: string): Observable<any> {
//   return new Observable((observer) => {
//     this.socket.on('percentage-progress', (data) => {
//       console.log("percentage-progress",data)
//       if (data.projectId === projectId) {
//         observer.next(data); // Emit the data to the subscriber
//       }
//     });
//   });
// }

// // Observable to listen for completion
// onComplete(projectId: string): Observable<any> {
//   return new Observable((observer) => {
//     this.socket.on('percentage-complete', (data) => {
//       console.log('percentage-complete',data)
//       if (data.projectId === projectId) {
//         observer.next(data); // Emit the completion event
//       }
//     });
//   });
// }

// // Observable to listen for error
// onError(projectId: string): Observable<any> {
//   return new Observable((observer) => {
//     this.socket.on('percentage-error', (data) => {
//       if (data.projectId === projectId) {
//         observer.error(data); // Emit error if something goes wrong
//       }
//     });
//   });
// }

// // Emit subscription to project
// subscribeToProject(projectId: string): void {
//   console.log("subscribeToProject  called")
//   this.socket.emit('subscribe-to-project', projectId);
// }

// // Disconnect the socket (optional, depending on your needs)
// disconnect(): void {
//   this.socket.disconnect();
// }
getPercentage(iProjectId:any){
  const apiURL = `${environment.quote_url}mproject/get-percentage?iProjectId=${iProjectId}`;
  return this.http.get<any>(apiURL);
}
}

    